import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.scss';
import logo from '../assets/images/logo-1.png';

const Navbar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const solutions = [
    { name: 'Ecommerce', path: '/solutions/ecommerce' },
    { name: 'Insurance', path: '/solutions/insurance' },
    { name: 'Healthcare', path: '/solutions/healthcare' },
    { name: 'Customer Service', path: '/solutions/customer-service' },
    { name: 'Email Automation', path: '/solutions/email-automation' },
    { name: 'Retail', path: '/solutions/retail' },
    { name: 'Banking', path: '/solutions/banking' },
    { name: 'Telecom', path: '/solutions/telecom' },
    { name: 'Real Estate', path: '/solutions/real-estate' },
    { name: 'AI Recruiting', path: '/solutions/ai-recruiting' },
  ];

  const resources = [
    { name: 'Case Studies', path: '/resources/case-studies' },
    { name: 'Blog', path: '/resources/blog' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="navbar__container">
        <Link to="/" className="navbar__logo">
          <img src={logo} alt="Skil.AI" style={{ height: '40px', width: 'auto' }} />
        </Link>
        <div className="navbar__links">
          <Link 
            to="/" 
            className={`navbar__link ${isActive('/') ? 'active' : ''}`}
          >
            HOME
          </Link>

          <Link 
            to="/features" 
            className={`navbar__link ${isActive('/features') ? 'active' : ''}`}
          >
            FEATURES
          </Link>

          <div 
            className="navbar__dropdown"
            onMouseEnter={() => setActiveDropdown('solutions')}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            <Link to="/solutions" className="navbar__dropdown-button">
              SOLUTIONS
            </Link>
            {activeDropdown === 'solutions' && (
              <div className="navbar__dropdown-menu">
                {solutions.map((solution) => (
                  <Link
                    key={solution.path}
                    to={solution.path}
                    className={`navbar__dropdown-item ${isActive(solution.path) ? 'active' : ''}`}
                  >
                    {solution.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <div 
            className="navbar__dropdown"
            onMouseEnter={() => setActiveDropdown('resources')}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            <Link to="/resources" className="navbar__dropdown-button">
              RESOURCES
            </Link>
            {activeDropdown === 'resources' && (
              <div className="navbar__dropdown-menu">
                {resources.map((resource) => (
                  <Link
                    key={resource.path}
                    to={resource.path}
                    className={`navbar__dropdown-item ${isActive(resource.path) ? 'active' : ''}`}
                  >
                    {resource.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link 
            to="/privacy-policy" 
            className={`navbar__link ${isActive('/privacy-policy') ? 'active' : ''}`}
          >
            PRIVACY POLICY
          </Link>

          <Link 
            to="/contact" 
            className={`navbar__link ${isActive('/contact') ? 'active' : ''}`}
          >
            CONTACT
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 
